import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {ClientDienst} from '../client-dienst';
import {DialogService} from '../../core/dialog/dialog.service';
import {Diensten} from '../../dienst/diensten';
import {firstValueFrom, Observable} from "rxjs";
import {ZoneService} from "../../zone/zone.service";
import {Zone} from "../../zone/zone";

@Component({
    selector: 'zah-client-diensten-beheer',
    templateUrl: './client-diensten-beheer.component.html',
    styleUrls: ['./client-diensten-beheer.component.scss'],
    standalone: false
})
export class ClientDienstenBeheerComponent implements OnInit {
  private dialogService = inject(DialogService);
  private zoneService = inject(ZoneService);

  @Input()
  clientDiensten: Array<ClientDienst>;
  @Input()
  diensten: Diensten;
  @Output()
  clientDienstenChange: EventEmitter<Array<ClientDienst>> = new EventEmitter<Array<ClientDienst>>();

  private expandedDienstId: string;
  zones$: Observable<Array<Zone>>;

  // TODO zones meegeven vanuit de page
  ngOnInit(): void {
    this.zones$ = this.zoneService.getZones$();
  }

  async onAddClick(): Promise<void> {
    const dienst = await firstValueFrom(
      this.dialogService.askSelection({
        message: 'Kies de dienst die je wil toevoegen:',
        optionList: this.getDienstenToAdd().getDiensten(),
        defaultValue: this.getDienstenToAdd().getFirst(),
        confirmLabel: 'Voeg toe'
      })
    );

    const availableZones = await firstValueFrom(this.zoneService.getZonesFor$(dienst.getAvailableZoneIds()));

    const zone = await firstValueFrom(
      this.dialogService.askSelection({
        message: 'Kies de zone voor de geselecteerde dienst:',
        optionList: availableZones,
        defaultValue: availableZones[0],
        confirmLabel: 'Voeg toe'
      })
    );

    this.expandedDienstId = dienst.getId();
    this.clientDienstenChange.emit([...this.clientDiensten, ClientDienst.new(dienst, zone.getId())]);
  }

  onDeleteClick(clientDienstToDelete: ClientDienst): void {
    this.expandedDienstId = undefined;
    this.clientDienstenChange.emit(
      this.clientDiensten.filter(clientDienst => !clientDienst.hasId(clientDienstToDelete.getId()))
    );
  }

  isExpanded(clientDienst: ClientDienst): boolean {
    return this.expandedDienstId === clientDienst.getId();
  }

  hasDienstToAdd(): boolean {
    return !this.getDienstenToAdd().isEmpty();
  }

  private getDienstenToAdd(): Diensten {
    const clientDienstIds = this.clientDiensten.map(clientDienst => clientDienst.getId());
    return this.diensten.without(clientDienstIds);
  }
}
